import { Component, OnInit, Input } from "@angular/core";
import { MatTableDataSource, MatSort, MatPaginator } from "@angular/material";
import { Router, ActivatedRoute } from "@angular/router";
import { DataService } from "src/app/data.service";
import { ToastService } from "ng-uikit-pro-standard";

import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { Sort } from "@angular/material/sort";

@Component({
  selector: "app-refinedlayoutlist",
  templateUrl: "./refinedlayoutlist.component.html",
  styleUrls: ["./refinedlayoutlist.component.scss"],
})
export class RefinedlayoutlistComponent implements OnInit {
  @Input() metaobjectid: string;
  @Input() objectname: string;
  @Input() parentobjectid: string;
  @Input() parentobjectname: string;
  @Input() embeddedobject: boolean;
  profileId = "";
  metaobjectId = "";
  objectName = "";
  parentobjectId = "";
  parentobjectName = "";
  embeddedObject: boolean;
  matSort: any;
  isLoading = false;
  isError = false;
  errorMessage = "";
  refineLayoutList = [];

  sorting = {
    fieldName: "displayname",
    order: "ASC",
  };

  sortData(sort: Sort) {
    console.log("sort", sort);
    if (!sort.active || sort.direction === "") {
      //default sorting
      this.sorting.fieldName = "createddate";
      this.sorting.order = "ASC";
    } else {
      const isAsc = sort.direction.toLocaleUpperCase() === "ASC";
      this.sorting.fieldName = sort.active;
      if (isAsc) {
        this.sorting.order = "ASC";
      } else {
        this.sorting.order = "DESC";
      }
    }

    this.getRefineLayouts().then((res) => {
      console.log("response11111", res);
    });
  }

  displayedColumns: string[] = [
    "id",
    "displayname",
    "viewname",
    "action",
    "modifiedby",
    "modifieddate",
    "active",
  ];
  dataSource = new MatTableDataSource();
  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }
  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private dataService: DataService,
    private toastrService: ToastService

  ) {}

  ngOnInit() {
    this.metaobjectId = this.metaobjectid;
    this.objectName = this.objectname;
    this.parentobjectId = this.parentobjectid;
    this.parentobjectName = this.parentobjectname;
    this.embeddedObject = this.embeddedobject;
    var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));
    this.profileId = userDetail.profileid;


    this.getRefineLayouts().then((res) => {
      console.log("response11111", res);
    });
  }

  newRefinedLayout() {
    this.router.navigateByUrl(
      "/home/refinedlayout/new/" +
        this.metaobjectId +
        "/" +
        this.objectName +
        "/" +
        this.profileId
    );
  }

  getRefineLayouts() {
    return new Promise((resolve, reject) => {
      console.log("getCustomviews");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
        subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
        data: {
          sortfield: this.sorting.fieldName,
          sortorder: this.sorting.order,
          metalayout: {
            metaobjectid: this.metaobjectId,
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getRefineLayouts(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.refineLayoutList = res.data.metalayouts;

            // Show the customview except Recent
            // this.customviewList = res.data.metalayouts.filter(customview => customview.name !== 'Recent');

            //assign table data will refresh it automatically
            this.dataSource.data = this.refineLayoutList;

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No refinelayouts data!");
            this.errorMessage =
              res != null ? res.message : "No refinelayouts data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }


  delete(id: number) {
    // alert(id)
   const organizationid = localStorage.getItem("crm_orgid")
   const domain = localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`);
   const subdomain = localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`);
   const confirmDelete = window.confirm("Are you sure you want to delete?");
  
 if (!confirmDelete) {
   return;
 }
    this.isLoading = true;
    this.dataService.deleteMetalayout(organizationid,domain,subdomain,this.metaobjectid,id).subscribe(
      res => {
        // alert('****res****' + JSON.stringify(res));
        console.log(res);
        if(res.success == 1){
          // alert("Are you sure?")
          window.location.reload()
          
          this.isLoading = false;

          this.showSuccess(res.message);

        }
        else{
          console.log("Failed to delete!");
          this.isLoading = false;
          this.showError(res.message);

        }
      },
      err =>{
        console.log("Error***:",err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        this.showError(err.message);

      }
    );
  
  
  }
}
